var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-alert',{attrs:{"color":"warning","active":"true"}},[_c('p',[_vm._v("Are you there ...?")]),_c('p',[_vm._v("you will be logged out after "+_vm._s(_vm.time / 1000)+" Seconds")])])
}
var staticRenderFns = []

export { render, staticRenderFns }